import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import CityPicker from '../../booking/location/CityPicker';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(0.5),
        },
        marginTop: '1rem'
    },
}));

const MemberLocationList = ({ value = [], list, title, subtitle, onChange }) => {
    const [locations, setLocations] = useState(value)

    const handleChange = city => {
        if (!locations.find(l => l.id === city.id)) {
            const updated = [...locations, city];

            setLocations(updated);
            onChange({ [list]: updated })
        }
    }

    const handleDelete = city => {
        const updated = locations.filter(l => l.id !== city.id);

        setLocations(updated);
        onChange({ [list]: updated })
    }
    
    const classes = useStyles();

    return (<div style={{marginTop: '1rem'}}>
        <Typography variant="h5" color="initial">{title}</Typography>
        <Typography variant="subtitle2" color="initial">{subtitle}</Typography>
        <div style={{marginTop: '1rem'}}>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <CityPicker onChange={handleChange} />
                </Grid>
                <Grid item xs={8}>
                    <div className={classes.root}>
                        {
                            locations.map(city => {
                                return <Chip key={city.id} label={city.name} onDelete={() => handleDelete(city)} color="primary" />
                            })
                        }
                    </div>
                </Grid>
            </Grid>
        </div>
    </div>);
};

export default MemberLocationList;